import Phaser from 'phaser';
import {gsap} from 'gsap';


export default class Birth{

    constructor(){
        GAME_REF.obj.birth = this;
        this.scene = GAME_REF.scene;
        this.manager = GAME_REF.obj.manager;

        this.container = null;
        this.inner = null;
        this.lightTween = null;
        this.dragonTween = null;
        this.birthpos = {left:0, center:320, right:600};

        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);
        this.hideTimer = null;

        this._init();
    }


    render(frameNo, pos){
        this.dragon_inner.setFrame(frameNo);
        this.egg1.setFrame(frameNo);
        this.egg2.setFrame(frameNo);

        this.inner.x = this.birthpos[pos];
        
        this.lightTween.resume();
        this.dragonTween.resume();
        this._renderAnime();
        this.container.setVisible(true);

        this.hideTimer = gsap.delayedCall(1.8, ()=>{
            this.manager.next();
            this.hideTimer = null;
        });

        GAME_REF.obj.sound.playOne('se_birth');
        this.$close.classList.add('-disable'); 

        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }


    hide(){
        window.removeEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.removeEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);

        this.lightTween.pause();
        this.dragonTween.pause();
        this.container.setVisible(false);
        this.$close.classList.remove('-disable');
    }


    _init(){
        this.$close = document.querySelector('.c-btn_return');
        this._create();
        this._loopAnime();
    }

    _create(){
        this.container = this.scene.add.container(0, 0);
        this.container.setDepth(50);
        this.container.setVisible(false);

        this.overlay = this.scene.add.graphics();
        this.overlay.fillStyle(0xFFFFFF);
        this.overlay.fillRect(0, 0, 1280, 775);
        this.overlay.alpha = 0.9;
        this.container.add(this.overlay);

        this.inner = this.scene.add.container(0, 0);
        this.container.add(this.inner);

        this.light = this.scene.add.image(364, 400, 'get_light');
        this.light.setOrigin(0.5, 0.5);
        this.inner.add(this.light);

        this.star = this.scene.add.image(350, 420, 'get_star');
        this.star.setOrigin(0.5, 0.5);
        this.star.alpha = 0;
        this.inner.add(this.star);

        this.point = this.scene.add.image(336, 180, 'get_scoreup');
        this.point.setOrigin(0.5, 0.5);
        this.point.alpha = 0;
        this.inner.add(this.point);

        this.dragon = this.scene.add.container(350, 630);
        this.dragon.setScale(0.5);
        this.dragon.setVisible(false);
        this.inner.add(this.dragon);

        this.dragon_inner = this.scene.add.sprite(0, 0, 'get_dragon');
        this.dragon_inner.setOrigin(0.5, 1);
        this.dragon_inner.setFrame(0);
        this.dragon.add(this.dragon_inner);

        this.egg1 = this.scene.add.sprite(370, 470, 'get_break1');
        this.egg1.setOrigin(0.5, 0.5);
        this.egg1.angle = -35;
        this.egg1.setFrame(0);
        this.inner.add(this.egg1);

        this.egg2 = this.scene.add.sprite(350, 380, 'get_break2');
        this.egg2.setOrigin(0.5, 0.5);
        this.egg2.setScale(1.1);
        this.egg2.angle = -105;
        this.egg2.setFrame(0);
        this.inner.add(this.egg2);
    }

    _loopAnime(){

        this.lightTween = this.scene.tweens.add({
            targets: this.light,
            angle: 360,
            ease: 'Linear',
            duration: 7000, 
            repeat: -1,
            paused: true,
        });

        this.dragonTween = this.scene.tweens.add({
            targets: this.dragon_inner,
            scaleY: 0.99,
            duration: 400,
            delay: Math.floor(Math.random() * 1000),
            ease: 'Sine.easeInOut',
            yoyo: true, 
            repeat: -1,
            paused: true,
        });
    }

    _renderAnime(){

        // たまご
        this.egg1.x = 370;
        this.egg1.y = 470;
        this.egg1.angle = -35;

        this.egg2.x = 350;
        this.egg2.y = 380;
        this.egg2.setScale(1.1);
        this.egg2.angle = -105;

        this.scene.tweens.add({
            targets: this.egg1,
            x: 245,
            y: 615,
            angle: 0,
            duration: 700,
            ease: 'Cubic.easeOut',
        });

        this.scene.tweens.add({
            targets: this.egg2,
            x: 570,
            y: 500,
            scaleX: 1,
            scaleY: 1,
            angle: 0,
            duration: 700,
            delay: 10,
            ease: 'Cubic.easeOut',
        });

        // ドラゴン
        this.dragon.setScale(0.5);
        this.dragon.setVisible(false);
        this.scene.tweens.add({
            targets: this.dragon,
            scaleX: 1,
            scaleY: 1,
            duration: 500,
            delay: 300,
            ease: 'Back.easeOut',
            onStart: ()=>{
                this.dragon.setVisible(true);
            }
        });


        // スコアUP
        this.point.alpha = 0;
        this.point.y =180;

        this.scene.tweens.add({
            targets: this.point,
            y: 160,
            duration: 600,
            delay: 1000,
            ease: 'Cubic.easeOut',
        });
        this.scene.tweens.add({
            targets: this.point,
            alpha: 1,
            duration: 100,
            delay: 1000,
            ease: 'Cubic.easeOut',
        });


        // 星
        this.star.setScale(0.5);
        this.star.alpha = 0;

        this.scene.tweens.add({
            targets: this.star,
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            duration: 600,
            delay: 200,
            ease: 'Cubic.easeOut',
        });
    }


    _pause(){
        if(this.hideTimer) this.hideTimer.pause();
    }

    _resume(){
        if(this.hideTimer) this.hideTimer.resume();
    }
}